import store from '@/store/index'
import $config from './ht.config'
import { MessageBox, Message } from 'element-ui'
import router from '@/router/index'
export default {
  islogin(fn) {
    if (!store.getters.islogin) {
      MessageBox.confirm('您的账号尚未登陆，是否去登陆？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          router.push({ path: '/login' })
        })
        .catch(() => {})
    } else {
      fn()
    }
  },
  setRecord(model, config) {
    if (config) {
      for (let key in config) {
        model[key] = config[key]
      }
    }
    model['uuid'] = this.UUID(32)
    model['rowAction'] = 'N'
    return model
  },
  ToArry(res, key) {
    if (key) {
      if (res[key]) {
        return res[key] instanceof Array ? res[key] : [res[key]]
      } else {
        return []
      }
    } else {
      if (res) {
        return res instanceof Array ? res : [res]
      } else {
        return []
      }
    }
  },
  QParam(key, value, op, orGroup) {
    if (orGroup) {
      return {
        key: key,
        value: value,
        op: $config[op],
        orGroup: orGroup,
      }
    } else {
      return { key: key, value: value, op: $config[op] }
    }
  },

  UUID(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = []
    radix = radix || chars.length

    if (len) {
      for (var i = 0; i < len; i++) {
        uuid[i] = chars[0 | (Math.random() * radix)]
      }
    } else {
      var r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16)
          uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
        }
      }
    }
    return uuid.join('')
  },

  HTJ(json) {
    return { HtRequest: json }
  },

  QTJ(a) {
    return { HtQuery: a }
  },

  QATJ(a) {
    return JSON.stringify(this.HTJ(this.QTJ(a)))
  },
  //
  RXML(r, rt) {
    return { xml: this.RTJOSN(r, rt) }
  },
  RTJOSN(r, rt) {
    if (rt) {
      if (r instanceof Array) {
        return JSON.stringify(this.HTJ(this.RATJ(r, rt)))
      } else {
        return JSON.stringify(this.HTJ(this.RTJ(r, rt)))
      }
    } else {
      let arry = []
      for (let key in r) {
        let str
        if (r[key] instanceof Array) {
          str = JSON.stringify(this.RATJ(r[key], key))
        } else {
          str = JSON.stringify(this.RTJ(r[key], key))
        }
        str = str.slice(1, str.length - 1)
        arry.push(str)
      }
      return '{"HtRequest":{' + arry.join(',') + '}}'
    }
  },

  /** 一条数组记录转换成json格式字符串
   * @param {数组记录} ra
   * @param {记录类型} rt
   * @return {}
   */
  RATJ(ra, rt) {
    var arry = []
    var me = this
    ra.forEach(function (r, i) {
      arry.push(me.RTJS(r))
    })
    return { [rt]: arry }
  },

  /** 一条记录转换成json格式字符串
   * @param {记录} r
   * @param {记录类型} rt
   * @return {}
   */
  RTJ(r, rt) {
    return { [rt]: this.RTJS(r) }
  },

  /** 单个数据记录转换成json字符串 */
  RTJS(Obj) {
    let jsonA = {}
    for (let i in Obj) {
      if (Obj[i] !== null && Obj[i] !== undefined) {
        jsonA[i] = Obj[i]
      }
    }
    if (jsonA.id) {
      if (jsonA.removed === 1 || jsonA.rowAction === 'R') {
        jsonA.rowAction = 'R'
      } else {
        jsonA.rowAction = 'M'
      }
    } else {
      jsonA.rowAction = 'N'
    }

    return jsonA
  },
  // 格式化日期
  formatDate(date, fmt) {
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  },
  // 判断对象是否为空
  isEmptyObject(O) {
    for (var x in O) {
      return false
    }
    return true
  },
  // 确认弹框
  doConfirm(msg) {
    return MessageBox.confirm(msg, '提示', {
      type: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      lockScroll: false,
    })
  },
  // 成功消息
  doSuccess(msg) {
    Message({
      message: msg,
      type: 'success',
      duration: 2500,
    })
  },
  // 错误消息
  doError(msg) {
    Message({
      message: msg,
      type: 'error',
      duration: 2500,
    })
  },
  // 警示消息
  doWarning(msg) {
    Message({
      message: msg,
      type: 'warning',
      duration: 2500,
    })
  },
  weekTrans(day) {
    switch (day) {
      case 1:
        return '周一'

      case 2:
        return '周二'

      case 3:
        return '周三'

      case 4:
        return '周四'

      case 5:
        return '周五'

      case 6:
        return '周六'

      case 7:
        return '周日'
    }
  },
}
